import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addWinner, hideModal } from "../features/boardSlice";
import "../assets/styles/modal.css";

const Modal = () => {
  const dispatch = useDispatch();
  const { showModal } = useSelector((store) => store.board);
  const [error, setError] = useState(false);
  const [name, setName] = useState("");

  function changeHandler(e) {
    setName(e.target.value);
  }

  const clickHandler = () => {
    if (name.length === 0) setError(true);
    else {
      setError(false);
      dispatch(addWinner(name));
      setName("");
    }
  };

  return (
    showModal && (
      <div className="modal">
        <div className="modal-inner">
          <h3>Well done! You're in the top 10 now!</h3>
          <h4>Please add your name here: </h4>
          <input
            type="text"
            name="name"
            id="name"
            placeholder="Enter your name"
            value={name}
            onChange={changeHandler}
          />
          <div className="buttons">
            {error && <div className="error">You must enter your name!</div>}
            <button className="ok-btn" onClick={clickHandler}>
              OK
            </button>
            <button
              className="cancel-btn"
              onClick={() => {
                dispatch(hideModal());
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default Modal;
